var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder-wrap"},[_c('div',{staticClass:"placeholder-box",style:(_vm.style)},[_c('span',{staticClass:"placeholder-item placeholder-ani"})])])}
var staticRenderFns = []

export { render, staticRenderFns }